module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "aria-label": "Epigraph",
      "epub:type": "backmatter"
    }
  }, [_c('p', {
    staticClass: "epi"
  }, [_c('span', {
    attrs: {
      "aria-label": " Page x. ",
      "epub:type": "pagebreak",
      "id": "pg_x",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("“Darkness doesn’t kill the light—it defines it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_c('b', [_vm._v("—Richard Wagamese")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-542f3a64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 72
// module chunks = 0